import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-password-feedback',
  templateUrl: './password-feedback.component.html',
  styleUrls: ['./password-feedback.component.scss'],
  standalone: false,
})
export class PasswordFeedbackComponent implements OnInit {
  @Input()
  feedback = { warning: null, suggestions: null };

  constructor() {}

  ngOnInit() {}
}
